import { useContext, useMemo } from 'react';
import AuthContext from '../contexts/AuthContext/AuthContext';

/**
 * Hook customizado para gerenciar e verificar o status do plano FREE
 * Retorna informações sobre expiração, dias restantes e nível de urgência
 */
export default function useFreePlanStatus() {
  const { user } = useContext(AuthContext);
  
  const status = useMemo(() => {
    // Se não há usuário ou não é plano FREE, retorna estado inativo
    if (!user || !user.is_free_plan) {
      return { 
        isFreePlan: false,
        isLegacyUser: false,
        expirationDate: null,
        daysRemaining: null,
        isExpired: false,
        shouldShowWarning: false,
        urgencyLevel: null,
        message: null,
        periodType: null,
        backendMessage: null
      };
    }
    
    const daysRemaining = user.free_days_remaining || 0;
    const isExpired = user.is_free_expired || false;
    const periodType = user.period_type || null;
    const backendMessage = user.free_expired_message || null;
    
    // Determinar nível de urgência
    let urgencyLevel = null;
    let message = null;
    
    if (isExpired) {
      urgencyLevel = 'blocked';
      message = backendMessage || 'Seu período gratuito expirou';
    } else if (daysRemaining <= 1) {
      urgencyLevel = 'danger';
      message = daysRemaining === 1 
        ? 'Último dia de acesso gratuito!' 
        : 'Seu acesso gratuito expira hoje!';
    } else if (daysRemaining <= 7) {
      urgencyLevel = 'warning';
      message = `Atenção: faltam apenas ${daysRemaining} dias para seu acesso expirar`;
    } else if (daysRemaining <= 30) {
      urgencyLevel = 'info';
      message = `Seu período gratuito expira em ${daysRemaining} dias`;
    }
    
    return {
      isFreePlan: true,
      isLegacyUser: user.is_legacy_user || false,
      expirationDate: user.free_expiration_date,
      daysRemaining,
      isExpired,
      shouldShowWarning: daysRemaining <= 30 && !isExpired,
      urgencyLevel,
      message,
      periodType,
      backendMessage
    };
  }, [user]);
  
  return status;
}
